import semanticColorStyles from '@design/styles/SemanticColor.module.scss';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './ExposureDirection.module.scss';

interface ExposureDirectionProps {
  exposureDirection?: 'negative' | 'neutral' | 'positive';
}

export const ExposureDirectionCellContent = ({
  exposureDirection,
}: ExposureDirectionProps) => {
  const { t } = useTranslation(['common']);

  if (!exposureDirection) {
    return null;
  }

  return (
    <span
      className={clsx(styles.exposureDirection, {
        [semanticColorStyles.directionNegative]:
          exposureDirection === 'negative',
        [semanticColorStyles.directionNeutralSoft]:
          exposureDirection === 'neutral',
        [semanticColorStyles.directionPositive]:
          exposureDirection === 'positive',
      })}
    >
      {t(`common:${exposureDirection}`)}
    </span>
  );
};
